import React from 'react';
import SettingsIcon from '@atlaskit/icon/glyph/settings';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { GadgetFallback } from '@atlassian/jira-dashboard-internal-common';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

export const UnconfiguredGadgetWallboardFallback = ({ id }: { id: string }) => {
	const { formatMessage } = useIntl();

	return (
		<GadgetFallback
			icon={
				<SettingsIcon
					label={formatMessage(messages.settingsIconLabel)}
					primaryColor={token('color.icon', colors.N500)}
				/>
			}
			id={id}
		>
			{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
			<p>{formatMessage(messages.mainMessage)}</p>
			<p>{formatMessage(messages.configureInstructions)}</p>
		</GadgetFallback>
	);
};
